import Login from './Login'
import LoginContainer from './LoginContainer'
export { Login }
export { LoginContainer }
export default LoginContainer



// WEBPACK FOOTER //
// ./src/pages/Login/index.js